
<div class="use" *ngIf="show.use">
    <app-kontablenew
    title = "{{'voucherCouponsMg.title_Use' | translate}}"
    id="use_Table"
    [columns] = "[
    { field: 'channel', title: 'voucherCouponsMg.dt_use_channel', sortable:false },
    { field: 'storeId', title: 'voucherCouponsMg.dt_use_pv', sortable:false },
    { field: 'dateTime', title: 'voucherCouponsMg.dt_use_date', bodyTemplate: dateTimeTemplate },
    { field: 'transaction', title: 'voucherCouponsMg.dt_use_trans', sortable:false },
    { field: 'terminalId', title: 'voucherCouponsMg.dt_use_cash', sortable:false },
    { field: 'operationId', title: 'voucherCouponsMg.dt_use_oper', sortable:false },
    { field: 'message', title: 'voucherCouponsMg.dt_use_message', sortable:false }
  ]"
  [paginationType]="paginationType_Use"
  [showGlobalFilter]="false"
  [showReport]="false"
  [showInfoButton]="true"
  [showAddButton]="false"
  [showEditButton]="false"
  [showDeleteButton]="false"
  [showRecoverButton]="false"
  [showDetailsButton]="false"
  [fixedFilters]="initialFilters.use"
  [service]="srvVoucherCoupon"
  [methodsNames]="methodsNames.use"
  [columnFiltersEnabled]="false"
  [showResetFiltersBtn]="false"
  (onInfo)="info($event)"
  #Use>


  <ng-template #dateTimeTemplate data-testid="dateTimeTemplate" let-row>
    <span>{{getDateTime(row.dateTime)}}</span>
  </ng-template>

  <ng-template #printedTemplate data-testid="printedTemplate" let-row>
    <span *ngIf="row.printed === true">{{'common.yes' | translate}}</span>
    <span *ngIf="row.printed === false">{{'common.no' | translate}}</span>
  </ng-template>

  </app-kontablenew>
</div>

<p-dialog [positionLeft]="0" header="Details" [(visible)]="show.modal" [modal]="true" width="'100%'" [draggable]="false" [resizable]="false">
  <div *ngIf="show.modal">

    <p-tabView (onChange)="onChangeTab($event)" [styleClass]="'kTabView'">
      <p-tabPanel header="{{'voucherCouponsMg.tabConfirm' | translate}}"  [headerStyle]="{'width': (100/shownTabs.total) + '%'}" [headerStyleClass]="'kTabHead'">
        <div class="confirm" *ngIf="show.confirm">
          <app-kontablenew
          title = "{{'voucherCouponsMg.tabConfirm' | translate}}"
          id="useConfirm_Table"
          [columns] = "[
          { field: 'storeId', title: 'voucherCouponsMg.dt_use_confirm_pv', sortable:false },
          { field: 'dateTime', title: 'voucherCouponsMg.dt_use_confirm_date', bodyTemplate: dateTimeTemplate, sortable: false },
          { field: 'message', title: 'voucherCouponsMg.dt_use_confirm_message', sortable:false }
        ]"
        [paginationType]="paginationType_Use"
        [showGlobalFilter]="false"
        [showReport]="false"
        [showAddButton]="false"
        [showAddButton]="false"
        [showAddButton]="false"
        [fixedFilters]="initialFilters.use"
        [service]="srvVoucherCoupon"
        [methodsNames]="methodsNames.use"
        [columnFiltersEnabled]="false"
        [showResetFiltersBtn]="false"
        [showRowButtons]="false"
        #Use_Confirm>


        <ng-template #dateTimeTemplate data-testid="dateTimeTemplate" let-row>
          <span>{{getDateTime(row.dateTime)}}</span>
        </ng-template>

        <ng-template #printedTemplate data-testid="printedTemplate" let-row>
          <span *ngIf="row.printed === true">{{'common.yes' | translate}}</span>
          <span *ngIf="row.printed === false">{{'common.no' | translate}}</span>
        </ng-template>

        </app-kontablenew>
        </div>
      </p-tabPanel>
      <p-tabPanel header="{{'voucherCouponsMg.tabCancel' |translate}}" [headerStyle]="{'width': (100/shownTabs.total) + '%'}" [headerStyleClass]="'kTabHead'">
        <div class="cancel" *ngIf="show.cancel">
          <app-kontablenew
          title = "{{'voucherCouponsMg.tabCancel' |translate}}"
          id="useCancel_Table"
          [columns] = "[
          { field: 'storeId', title: 'voucherCouponsMg.dt_use_confirm_pv', sortable:false },
          { field: 'dateTime', title: 'voucherCouponsMg.dt_use_cancel_date', bodyTemplate: dateTimeTemplate, sortable: false },
          { field: 'message', title: 'voucherCouponsMg.dt_use_confirm_message', sortable:false }
        ]"
        [paginationType]="paginationType_Cancel"
        [showGlobalFilter]="false"
        [showReport]="false"
        [showAddButton]="false"
        [fixedFilters]="initialFilters.cancel"
        [service]="srvVoucherCoupon"
        [methodsNames]="methodsNames.cancel"
        [columnFiltersEnabled]="false"
        [showResetFiltersBtn]="false"
        [showRowButtons]="false"
        #UseCancel>


        <ng-template #dateTimeTemplate data-testid="dateTimeTemplate" let-row>
          <span>{{getDateTime(row.dateTime)}}</span>
        </ng-template>

        <ng-template #printedTemplate data-testid="printedTemplate" let-row>
          <span *ngIf="row.printed === true">{{'common.yes' | translate}}</span>
          <span *ngIf="row.printed === false">{{'common.no' | translate}}</span>
        </ng-template>

        </app-kontablenew>
        </div>
      </p-tabPanel>
    </p-tabView>

  </div>

</p-dialog>



// WEBPACK FOOTER //
// ./src/app/views/voucher-coupon-mg/voucher-coupon-mg-detail/use/use.component.html